var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{'pa-0 mb-15': _vm.$vuetify.breakpoint.smAndDown},
              {'px-3 py-4': _vm.$vuetify.breakpoint.mdAndUp}]},[(!_vm.isSpielFremdAdmin)?_c('spiel-berichte-offen-waiting',{class:[{'mx-0': _vm.$vuetify.breakpoint.smAndDown},
                                            {'mb-5': _vm.$vuetify.breakpoint.mdAndUp} ]}):_vm._e(),_c('spiel-berichte-offen-created')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }